import { Box, makeStyles, Modal } from '@material-ui/core';
import _ from 'lodash';
import Text from 'modules/Text';
import React, { useState, useRef, useEffect } from 'react';
import ImageLinks from 'resources/ImageLinks';
import theme from 'resources/theme';

const useStyles = makeStyles((theme) => ({
	box_wrap: {
		position: 'fixed',
		outline: 'none',
		top: 0,
		left: 120,
		width: 'calc(100% - 120px)',
		height: '100vh',
		display: 'flex',
		borderTopLeftRadius: '50px',
		justifyContent: 'center',
		alignItems: 'center',
		backdropFilter: 'blur(6px)',
		WebkitBackdropFilter: 'blur(6px)',
		backgroundColor: 'rgba(0,0,0,0.4)',
	},
	modal_box: {
		width: '100%',
		maxWidth: 900,
		height: '74vh',
		maxHeight: '90vh',
		flexDirection: 'column',
		display: 'flex',
		backgroundColor: '#fff',
		borderRadius: 12,
		boxShadow: 24,
	},
	footer_wrap: {
		display: 'flex',
		padding: '10px 10px 10px 12px',
		backgroundColor: '#FFEAEC',
		borderRadius: '8px',
		gap: '8px',
		alignItems: 'center',
	},
	refresh_wrap: {
		display: 'flex',
		width: '78px',
		height: '22px',
		padding: '8px 12px 8px 8px',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '4px',
		borderRadius: '30px',
		border: '2px solid #492897',
	},
}));

const LiveStreamVideoModal = ({ entity_details, close, live_video_url, refresh }) => {
	const [live_disable, set_live_disable] = useState(true);
	const classes = useStyles();
	const live_ref = useRef(null);

	const handle_refresh_button = () => {
		refresh();
		set_live_disable(true);
		if (live_ref.current) {
			clearTimeout(live_ref.current);
		}
		live_ref.current = setTimeout(
			() => {
				set_live_disable(false);
			},
			5 * 60 * 1000,
		);
	};

	useEffect(() => {
		live_ref.current = setTimeout(() => {
			set_live_disable(false);
		}, 30 * 1000);
		return () => {
			if (live_ref.current) {				
				clearTimeout(live_ref.current);
			}
		};
	}, []);

	return (
		<Modal open={true} hideBackdrop>
			<div className={classes.box_wrap}>
				<div className={classes.modal_box}>
					<div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 20px' }}>
						<Text medium>
							{_.get(entity_details, 'entity_name', '')} | {_.get(entity_details, 'owner_name', '')}{' '}
						</Text>
						<img className='cursor-pointer' src={ImageLinks.cross_black} onClick={close} alt='close' />
					</div>
					<div
						style={{
							flex: 1,
							background: 'black',
						}}>
						<iframe width='100%' height='100%' src={live_video_url} allowFullScreen frameBorder='0' />
					</div>
					<div style={{ display: 'flex', padding: '12px 20px', height: '46px', justifyContent: 'space-between' }}>
						<div className={classes.footer_wrap}>
							<img src={ImageLinks.info_circle_dark_pink} alt='alert' />
							<Text style={{ color: theme.colors.dark_purple_pink, fontSize: 12, fontWeight: '500' }}>This is a 15 min live video feed.</Text>
						</div>

						<button
							className={classes.refresh_wrap}
							style={{ background: live_disable ? '#ccc' : '#492897', border: live_disable ? 'none' : '2px solid #492897', cursor: live_disable ? 'not-allowed' : 'pointer' }}
							onClick={handle_refresh_button}
							disabled={live_disable}>
							<img src={ImageLinks.refresh_white} alt='refresh' style={{ width: '14px', height: '14px' }} />
							<Text style={{ color: '#fff', fontSize: 12, fontWeight: '600', whiteSpace: 'nowrap' }}>Refresh</Text>
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default LiveStreamVideoModal;
